import { combineReducers } from 'redux';

const editInitialState = {
  saveStatus: 0,
  wx: {
    uinfo: null,
    pnumber: null,
  },
  input: {
    preset: false,
    type: '',
    mobile: '',
    verify: '',
    pass: '',
    passConfirm: '',
    oldMobile: '',
    oldVerify: '',
    wechat: '',
    showWechat: '',
  },
};

function editReducer(state = editInitialState, action) {
  switch (action.type) {
    case 'SYNC_ACCOUNT_EDIT_INPUT':
    case 'SYNC_WECHAT_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? editInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'SYNC_ACCOUNT_EDIT_WX': {
      return {
        ...state,
        wx: {
          ...state.wx,
          ...action.wx,
        },
      };
    }

    case 'LOGOUT_ACCOUNT':
    case 'UNBIND_ACCOUNT':
    case 'LOGIN_ACCOUNT':
    case 'BIND_ACCOUNT':
    case 'RESET_MOBILE':
    case 'RESET_PASS':
    case 'EDIT_WECHAT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'LOGOUT_ACCOUNT_COMPLETION':
    case 'UNBIND_ACCOUNT_COMPLETION':
    case 'LOGIN_ACCOUNT_COMPLETION':
    case 'BIND_ACCOUNT_COMPLETION':
    case 'RESET_MOBILE_COMPLETION':
    case 'RESET_PASS_COMPLETION':
    case 'EDIT_WECHAT_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  edit: editReducer,
});
